import slugify from 'slugify';
import _ from 'lodash-es'

export default function (targetField, slugField) {

  return {
    watch: {
      [targetField](newVal) {
        _.set(this, slugField, slugify(newVal, {lower: true}));
      }
    }
  }

}
